import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';
import { IEntityCriteriaSimpleOperator } from '../../../../common/types/shared/entitySelection';
import { formatCriterionDisplayString } from '../helpers';
import { QueryableFieldsQuery } from '../../../../types/generated-types';

interface SimpleOperatorBuilderProps {
  selectionSpec: IEntityCriteriaSimpleOperator;
  onChange: (value: IEntityCriteriaSimpleOperator | string) => void;
  fieldsData: QueryableFieldsQuery['queryableFields'];
}

export const SimpleOperatorBuilder: React.FC<SimpleOperatorBuilderProps> = ({
  selectionSpec,
  onChange,
  fieldsData,
}) => {
  return (
    <Box>
      <FormControl sx={{ minWidth: 120, mb: 2 }}>
        <InputLabel>Operator</InputLabel>
        <Select
          value={selectionSpec.operator}
          onChange={(e) => onChange(e.target.value)}
          label="Operator"
        >
          <MenuItem value="AND">AND</MenuItem>
          <MenuItem value="OR">OR</MenuItem>
          <MenuItem value="NOR">NOR</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ ml: 2 }}>
        {selectionSpec.criteria.map((criterion) => (
          <Typography key={criterion.id} sx={{ mb: 1 }}>
            {formatCriterionDisplayString(criterion, fieldsData)}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
